import React from 'react';

import Styled from './styles';

interface ButtonTextProps extends React.ComponentPropsWithRef<'div'> {
  children: string;
}

/** <ButtonText/ > is made to be nested in <Button /> */
const ButtonText = (props: ButtonTextProps) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <Styled.ButtonText
      data-parent="button-text"
      {...otherProps}
    >
      {children}
    </Styled.ButtonText>
  );
};

export { ButtonText as default, ButtonTextProps };